const SET_ENHANCED_CONTENT = 'SET_ENHANCED_CONTENT';

export { SET_ENHANCED_CONTENT };
